import TableViewComponents from './tableView.vue'

const tableView = {
  install: function (Vue) {
    Vue.component('TableView', TableViewComponents)
  }
}

export default tableView
